import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { scrollToId } from "@/utils";

export const AiTeaser = () => {
  const { t } = useLang();
  const a = t.ai;

  return (
    <section id="ai" className="px-3 py-8 sm:px-5">
      <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-pine px-6 py-16 text-center sm:px-14 sm:py-20" data-testid="ai-insights-teaser-container">
        <div className="pointer-events-none absolute -start-24 -top-24 h-80 w-80 rounded-full bg-sun/15 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 -end-24 h-96 w-96 rounded-full bg-white/5 blur-3xl" />

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <span className="mx-auto flex w-fit items-center gap-2.5 rounded-full border border-sun/40 bg-sun/15 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-sun-light">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-sun opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-sun" />
            </span>
            {a.badge}
          </span>

          <h2 className="mx-auto mt-7 max-w-3xl font-display text-3xl font-bold tracking-tight text-cream sm:text-5xl">{a.title}</h2>
          <p className="mx-auto mt-5 max-w-2xl leading-relaxed text-cream/75">{a.body}</p>

          <div className="mt-9 flex flex-wrap justify-center gap-3">
            {a.chips.map((chip, i) => (
              <span key={i} className="flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-5 py-2.5 text-sm font-semibold text-cream">
                <Sparkles className="h-4 w-4 text-sun" />
                {chip}
              </span>
            ))}
          </div>

          <button onClick={() => scrollToId("quote")} className="mt-10 text-sm font-bold text-sun underline decoration-sun/40 underline-offset-4 transition-colors hover:text-cream" data-testid="ai-quote-link">
            {t.nav.quote}
          </button>
        </motion.div>
      </div>
    </section>
  );
};
